import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useUser } from "../UserContext";

const CommercialSalesContext = createContext();

export const CommercialSalesProvider = ({ children }) => {
  // const [getData, setGetData] = useState(true)
  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  const { marketPlace } = useUser()
  const [currentNegociation, setCurrentNegociation] = useState([])
  const [currentVisita, setCurrentVisita] = useState()
  const [currentScheduling, setCurrentScheduling] = useState(false)
  const [statusContext, setStatusContext] = useState()
  const [companiesVisitScheduled, setCompaniesVisitScheduled] = useState([])
  const [companies, setCompanies] = useState([])
  const [timer, setTimer] = useState("")
  const [intervalId, setIntervalId] = useState()
  const [industriesVisitScheduled, setIndustriesVisitScheduled] = useState([])
  const [approvedNegociations, setApprovedNegociations] = useState([])
  const storagedUser = JSON.parse(localStorage.getItem('@App:user'));
  const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
  const currentRodada = JSON.parse(localStorage.getItem("@App:rodada"))

  function getApprovedNegociation() {

    api.get(`/api/venda/listarIndustria/${storagedIndustry?.industria}/${currentRodada.rodada}/A`)
      .then(response => {
        setApprovedNegociations(response.data)
      })

  }

  function getCurrentNegociation(codVisita, idIndustry) {

    api.get(`/api/visita/listarNegociacoes/${codVisita}`)
      .then(response => {

        setCurrentScheduling(response?.data[0])
        setStatusContext(response?.data[0]?.status ? response?.data[0]?.status : "")
        setCurrentNegociation(response?.data[0]?.itens ? response?.data[0]?.itens : currentNegociation)

      })

  }

  const scheduleNewVisit = (markertToSchedule) => {

    const data = {
      "confirmada": false,
      "industria": storagedIndustry,
      "industriaUsuario": storagedUser,
      "rodada": currentRodada,
      "supermercado": markertToSchedule,
    }

    try {
      api.post("/api/visita/agendar", data)
        .then(response => {
          api.get(`/api/visita/listarIndustria/${storagedIndustry?.industria}/${currentRodada.rodada}`)
            .then(response => {
              console.log("newVisit")
              setCompaniesVisitScheduled(response.data)
            })
            .catch((error) => {
              console.log(error)
            })

          try {
            api.get(`/api/supermercado/listarSupermercadosSemAgendamento/${storagedIndustry?.industria}/${currentRodada.rodada}`)
              .then(response => setCompanies(response.data))
          } catch (error) {
            console.log(error)
          }
        })
    } catch (error) {
      console.log(error)
    }

  }
  function rejectNegociation() {

    const storagedUser = JSON.parse(localStorage.getItem('@App:user'));
    const now = new Date()
    const data = {
      "codVisita": currentVisita.visita,
      "dataAceite": `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`,
      "dataCadastro": `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`,
      "dataLimite": "",
      "itens": currentNegociation,
      "status": "E",
      "usuarioAceite": storagedUser,
      "usuarioCadastro": storagedUser,
      "visitaNegociacao": 0
    }



    try {
      api.post(`/api/visita/cadastrarNegociacao`, data)
        .then(response => {
          // setInfoNegociation(selectedCompany)
          setStatusContext("P")
          setCurrentScheduling(data)
        })
    } catch (error) {
      console.log(error)
    }


  }

  function aceptNegociation() {

    const storagedUser = JSON.parse(localStorage.getItem('@App:user'));
    const now = new Date()
    const data = {
      "codVisita": currentVisita.visita,
      "dataAceite": `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`,
      "dataCadastro": `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`,
      "dataLimite": "",
      "itens": currentNegociation,
      "status": "P",
      "usuarioAceite": storagedUser,
      "usuarioCadastro": storagedUser,
      "visitaNegociacao": currentScheduling.visitaNegociacao
    }

    try {
      api.post(`/api/visita/cadastrarNegociacao`, data)
        .then(response => {
          // setInfoNegociation(selectedCompany)
          setStatusContext("P")
          setCurrentScheduling(data)
          setTimer("")
        })
    } catch (error) {
      console.log(error)
    }

  }

  function finishNegociation(status, isIndustry) {
    const storagedUser = JSON.parse(localStorage.getItem('@App:user'));
    const now = new Date()

    const data = {
      "codVisita": currentVisita.visita,
      "dataAceite": "",
      "dataCadastro": `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`,
      "dataLimite": "",
      "itens": currentNegociation,
      "status": status,
      "usuarioAceite": null,
      "usuarioCadastro": storagedUser,
      "visitaNegociacao": 0
    }

    if (currentScheduling) {
      const dataReject = currentScheduling
      dataReject.status = "R"

      console.log("REJECTED", dataReject)

      try {
        api.post(`/api/visita/cadastrarNegociacao`, dataReject)
          .then(response => {
            // setInfoNegociation(selectedCompany)
            // setStatusContext(status)
            // setCurrentScheduling(data)
            api.post(`/api/visita/cadastrarNegociacao`, data)
              .then(response => {
                getCurrentNegociation(currentVisita?.visita)

                const newIntervalId = setInterval(() => {
                  getCurrentNegociation(currentVisita?.visita)
                }, 10000);
                setIntervalId(newIntervalId);
              }
              )

          })
      } catch (error) {
        console.log(error)
      }
    } else {
      api.post(`/api/visita/cadastrarNegociacao`, data)
        .then(response => {
          getCurrentNegociation(currentVisita?.visita)

          const newIntervalId = setInterval(() => {
            getCurrentNegociation(currentVisita?.visita)
          }, 10000);
          setIntervalId(newIntervalId);
        }
        )

    }

  }

  function finishedTimeVisita() {

    axios.post(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/visita/encerrarTempo/${currentVisita.visita}`)
      .then(
        response => {
          setCurrentScheduling(null)
          setCurrentNegociation([])
          setCurrentVisita(null)
          setStatusContext("")
          api.get(`/api/visita/listarIndustria/${storagedIndustry?.industria}/${currentRodada.rodada}`)
            .then(response => {
              console.log("finished")
              setCompaniesVisitScheduled(response.data)
            })
            .catch((error) => {
              console.log(error)
            })
        }
      )

  }

  function getCompaniesScheduled() {

    api.get(`/api/visita/listarIndustria/${storagedIndustry?.industria}/${currentRodada?.rodada}`)
      .then(response => {
        console.log("getCompanies")
        setCompaniesVisitScheduled(response.data)
      })

  }

  function getCompaniesNotScheduled() {
    api.get(`/api/supermercado/listarSupermercadosSemAgendamento/${storagedIndustry?.industria}/${currentRodada?.rodada}`)
      .then(response => setCompanies(response.data))
  }

  function getIndustriesScheduled() {
    if (!marketPlace?.supermercado) return

    api.get(`/api/visita/listarSupermercado/${marketPlace?.supermercado}/`)
      .then(response => {
        console.log("indsurao", response.data)
        setIndustriesVisitScheduled(response.data)
      })

  }

  useEffect(() => {

    if (currentVisita) {

      // if (currentScheduling) {

      //   if (currentScheduling.status !== "A") {

      //     var intervalo = window.setInterval(() => {

      //       getCurrentNegociation(currentVisita.visita)
      //       console.log("2")

      //     }, 100000);

      //   }

      // }

      setTimer(currentVisita?.dataHoraLimite)

    }

  }, [currentVisita])



  return (
    <CommercialSalesContext.Provider
      value={{
        setCurrentNegociation,
        currentNegociation,
        currentScheduling,
        setCurrentScheduling,
        finishNegociation,
        currentVisita,
        setCurrentVisita,
        getCurrentNegociation,
        statusContext,
        setStatusContext,
        companies,
        companiesVisitScheduled,
        finishedTimeVisita,
        scheduleNewVisit,
        getCompaniesScheduled,
        getCompaniesNotScheduled,
        timer,
        setTimer,
        aceptNegociation,
        rejectNegociation,
        intervalId,
        setIntervalId,
        industriesVisitScheduled,
        getIndustriesScheduled,
        getApprovedNegociation,
        approvedNegociations
      }}
    >
      {children}
    </CommercialSalesContext.Provider>
  );
};

export const useCommercialSales = () => useContext(CommercialSalesContext);
